/**
 * Type of all possible regions. Currently we only support region of Table
 */
export const enum RegionType {
    /**
     * Region split by Table
     */
    Table,
}
